import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

type CsocSubscriptionDetailsInput =
  | string
  | {userId: string; source?: string; platform?: string};

export default function useGetCsocSubscriptionDetailsApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<any, Error, CsocSubscriptionDetailsInput>(
    async (input: CsocSubscriptionDetailsInput) => {
      const userId = typeof input === 'string' ? input : input.userId;
      const source = typeof input === 'string' ? undefined : input.source;
      const platform = typeof input === 'string' ? undefined : input.platform;
      const response = await ChessRestClient.get(
        'subscription/v1/get_user_orders',
        {
          params: {
            user_id: userId,
            ...(source ? {source} : {}),
            ...(platform ? {platform} : {}),
          },
        },
      );
      console.log('Csoc Subscription details = ', response.data);
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
